export enum ROUTES {
  WORK_ORDERS_LIST = 'work-orders',
  WORK_ORDER = 'work-order',
  LOGIN = 'login',
  ERROR = 'error',
}

export const AUTH_HOME_ROUTE = ROUTES.WORK_ORDERS_LIST;
export const UNAUTH_HOME_ROUTE = ROUTES.LOGIN;
